import React from 'react';
import './UpdateButton.scss';

interface UpdateButtonProps {
  /** Function to handle update action */
  onUpdate: (e: React.FormEvent) => void;
  /** Custom class name */
  className?: string;
  /** Whether button is disabled */
  disabled?: boolean;
  /** Button label */
  label?: string;
  /** Whether update is in progress */
  isLoading?: boolean;
}

/**
 * Update button component with gray gradient styling
 * Used for update/save actions in forms
 */
const UpdateButton: React.FC<UpdateButtonProps> = ({
  onUpdate,
  className = '',
  disabled = false,
  label = 'Update',
  isLoading = false
}) => {
  const handleClick = (e: React.FormEvent) => {
    if (disabled || isLoading) return;
    onUpdate(e);
  };

  return (
    <button
      className={`update-button ${isLoading ? 'loading' : ''} ${className}`}
      onClick={handleClick}
      disabled={disabled || isLoading}
      type="submit"
    >
      {isLoading ? 'Updating...' : label}
    </button>
  );
};

export default UpdateButton;

